export class Association {
    public id: number | null = null;
    public name?: string;
    public selected: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    get value(): number | null {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }
}
